import { Box, Container, type ContainerProps } from "@mui/material";
import React from "react";

/** Shared full-viewport auth backdrop + centered container (login / register / forgot password). */
const heroSx = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundImage: "url(/images/background/bg8.jpg)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1,
  },
} as const;

type Props = React.PropsWithChildren<{
  maxWidth?: ContainerProps["maxWidth"];
}>;

export default function AuthPageFrame({ children, maxWidth = "md" }: Props) {
  return (
    <Box sx={heroSx}>
      <Container maxWidth={maxWidth} sx={{ position: "relative", zIndex: 2 }}>
        {children}
      </Container>
    </Box>
  );
}
